import { AppTextService } from '../app-text';
import { isDefined, FiDateFormatOptions } from '@fi-shared/utils';
import { AgreementPublishedContentModel, IAgreementPublishedContentModel } from './agreement-published-content.model';
import { ContentLanguageLabelModel } from '../models';
import { FiContentLanguageSharedService } from '../fi-content-language-shared/fi-content-language-shared.service';
import { ICreateChangeBase } from '../models/models';
import { IContentLanguageLabelModel } from '../fi-content-language-shared/fi-content-language-shared';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

export interface IAgreementModel extends ICreateChangeBase {
    Id: number;
    AgreementType: number;
    AgreementPublishedContents: IAgreementPublishedContentModel[];
    Description: string;
    AgreementVersions: any[]; // todo typing
    AgreementUserLogs: any[]; // todo typing
    IsDeleted: boolean;
}

export class AgreementModel {
    AgreementType: any;
    Name: string;
    Names: IContentLanguageLabelModel[];
    AgreementPublishedContents: AgreementPublishedContentModel[];
    AgreementVersions: any[];
    AgreementUserLogs: any[];
    Id: number;
    IsDeleted: boolean;
    Description: string;
    CreatedByUserId: number;
    CreatedOn: any;
    CreatedOnDate: string;
    ChangedByUserId: number;
    ChangedOn: any;
    ChangedOnDate: string;
    CreatedByUserName: string;
    ChangedByUserName: string;

    static TypeLicence = 1;
    static TypeConfidential = 2;
    selectedLanguage: number; // todo used only on frontend, remove from model

    constructor(appTextService: AppTextService, fiFormatDateService: FiFormatDateService, data?: IAgreementModel) {
        this.InitializeAgreement(appTextService, fiFormatDateService, data);
    }

    InitializeAgreement(
        appTextService: AppTextService,
        fiFormatDateService: FiFormatDateService,
        data: IAgreementModel,
    ) {
        data =
            data ||
            ({
                AgreementPublishedContents: [],
            } as IAgreementModel);
        const self = this;
        this.AgreementType = data.AgreementType || AgreementModel.TypeLicence;
        this.Name = appTextService.get(
            this.AgreementType == AgreementModel.TypeLicence
                ? 'agreement.licence_agreement'
                : 'agreement.confidencial_agreement',
        );
        this.Names = [];
        this.Description = data.Description;
        this.AgreementPublishedContents = [];
        data.AgreementPublishedContents.forEach(function (publishedContent) {
            self.AgreementPublishedContents.push(new AgreementPublishedContentModel(publishedContent));
        });

        this.AgreementVersions = data.AgreementVersions || [];
        this.AgreementUserLogs = data.AgreementUserLogs || [];
        this.Id = data.Id;
        this.IsDeleted = data.IsDeleted || false;
        this.Description = data.Description;
        this.CreatedByUserId = data.CreatedByUserId;
        this.CreatedOn = data.CreatedOn;
        this.CreatedOnDate = fiFormatDateService.formatDate(this.CreatedOn, FiDateFormatOptions);
        this.ChangedByUserId = data.ChangedByUserId;
        this.ChangedOn = data.ChangedOn;
        this.ChangedOnDate = fiFormatDateService.formatDate(this.ChangedOn, FiDateFormatOptions);
        this.CreatedByUserName = data.CreatedByUserName;
        this.ChangedByUserName = data.ChangedByUserName;
    }

    GetPublishedContentByContentLanguage(contentLanguageId: number, alternativeLanguageId?: number) {
        let languageContents = this.AgreementPublishedContents.filter(
            (item) => item.ContentLanguageId == contentLanguageId,
        );
        let languageContent = languageContents.length ? languageContents[0] : new AgreementPublishedContentModel();

        if (
            (!languageContent.ContentLanguageId ||
                !languageContent.Content ||
                !languageContent.Content.replace(/\s/g, '')) &&
            isDefined(alternativeLanguageId)
        ) {
            languageContents = this.AgreementPublishedContents.filter(
                (item) => item.ContentLanguageId == alternativeLanguageId,
            );
            languageContent = languageContents.length ? languageContents[0] : new AgreementPublishedContentModel();
        }

        return languageContent;
    }

    GetVersion(AgreementVersion, ContentLanguageId) {
        for (let i = 0; i < this.AgreementVersions.length; i++) {
            const version = this.AgreementVersions[i];
            if (version.AgreementVersion == AgreementVersion && version.ContentLanguageId == ContentLanguageId) {
                return version;
            }
        }
    }

    InitializeContentLanguages(contentLanguagesService: FiContentLanguageSharedService) {
        const self = this;
        const namesLanguages = [];
        this.Names.forEach(function (name) {
            namesLanguages.push(name.ContentLanguageId);
        });
        contentLanguagesService.getContentLanguages().forEach(function (contentLanguage) {
            if (namesLanguages.indexOf(contentLanguage.Id) == -1) {
                self.Names.push(new ContentLanguageLabelModel(contentLanguage.Id, '', contentLanguage.SortIndex));
            }
        });
    }
}
